export const ATTENDANCE_CLASSIFICATIONS_OPTIONS = [
  {
    value: '1',
    badgeText: 'Cinza',
    label: 'Sem classificação',
    description: 'Não sabe informar ou não há necessidade da classificação',
    color: 'gray',
  },
  {
    value: '2',
    badgeText: 'Azul',
    label: 'Não Urgente',
    description: 'Sem risco imediato de agravo à saúde',
    color: 'blue',
  },
  {
    badgeText: 'Verde',
    label: 'Pouco urgente',
    value: '3',
    description: 'Baixo risco imediato de agravo à saúde',
    color: 'green',
  },
  {
    badgeText: 'Amarelo',
    label: 'Urgente',
    value: '4',
    description: 'Condição que pode se agravar sem atendimento',
    color: 'yellow',
  },
  {
    badgeText: 'Laranja',
    label: 'Muito Urgente',
    value: '5',
    description: 'Risco imediato da perda de função de órgãos ou membros',
    color: 'orange',
  },
  {
    badgeText: 'Vermelho',
    label: 'Emergência',
    value: '6',
    description: 'Risco imediato de perder a vida',
    color: 'red',
  },
]
